import { FormSchema, FormControl } from "./types";

type PartialSchema = Omit<
    FormSchema,
    "getControl" | "getControlIndex" | "findControlsByType"
>;

const createSchema = ({
    controls = [],
    description = "",
    rules = [],
    title = "",
    button,
    defaultValues = {},
    ...props
}: Partial<FormSchema>): FormSchema => {
    const self = {
        ...props,
        controls: [...controls],
        description,
        rules,
        title,
        button,
        defaultValues
    };
    return Object.assign(self, schemaBehaviours(self));
};

/**
 * Form builder Behaviours
 * @param self
 */

const schemaBehaviours = (self: PartialSchema) =>
    Object.assign(
        {},
        canGetControl(self),
        canGetControlIndex(self),
        canFindControlsByType(self)
    );

const canGetControl = (form: PartialSchema) => ({
    getControl: (name: string): FormControl | undefined => {
        return form.controls.find(e => e.name === name);
    }
});

const canGetControlIndex = (form: PartialSchema) => ({
    getControlIndex: (name: string): number =>
        form.controls.findIndex(e => e.name === name)
});

const canFindControlsByType = (form: PartialSchema) => ({
    findControlsByType: (type: string): FormControl[] =>
        form.controls.filter(control => control.type === type)
});

export default createSchema;
